export const topics = [
  {
    id: 'topic-01',
    title: '本周娱乐爆料集中梳理：三条线索的相互印证过程',
    category: 'ent',
    categoryName: '娱乐爆料',
    author: '编辑 · 阿澜',
    date: '2026-09-10',
    hot: 4210,
    reading: '3 分钟',
    summary:
      '把本周散落的几条娱乐相关线索按时间线重新排列，标注每一条的信息来源与可信度区间，方便读者自行判断。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20timeline%20and%20spotlight%20shapes%20warm%20cream%20paper%20background%20minimal%20geometric%2C%20soft%20natural%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-01',
  },
  {
    id: 'topic-02',
    title: '数码新品爆料如何辨别真假：五点快速判断法',
    category: 'tech',
    categoryName: '科技数码',
    author: '编辑 · 周牧',
    date: '2026-09-09',
    hot: 3870,
    reading: '4 分钟',
    summary:
      '从参数逻辑、渲染图细节、发布时间点三个角度切入，总结一套普通用户也能上手的判断方法，减少被带偏的概率。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20magnifier%20and%20device%20shapes%20warm%20cream%20background%20minimal%20geometric%2C%20soft%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-02',
  },
  {
    id: 'topic-03',
    title: '财经话题讨论区观察：为什么复盘帖比预测帖更值得看',
    category: 'finance',
    categoryName: '财经观察',
    author: '编辑 · 林一舟',
    date: '2026-09-08',
    hot: 2960,
    reading: '5 分钟',
    summary:
      '观察一个月的财经讨论区帖子表现后发现，附有数据来源的复盘内容平均互动量更高，也更容易沉淀为长期参考。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20data%20columns%20and%20curves%20warm%20cream%20paper%20background%20minimal%20geometric%2C%20soft%20natural%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-03',
  },
  {
    id: 'topic-04',
    title: '消费避坑经验合集：一次完整的售后沟通记录复盘',
    category: 'life',
    categoryName: '生活消费',
    author: '编辑 · 苏念',
    date: '2026-09-07',
    hot: 2540,
    reading: '6 分钟',
    summary:
      '从下单到售后的完整时间线，附上每一步的沟通要点与话术模板，帮助遇到类似情况的读者更快推进处理。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20parcel%20and%20checklist%20shapes%20warm%20cream%20background%20minimal%20geometric%2C%20soft%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-04',
  },
  {
    id: 'topic-05',
    title: '社会热点讨论前的三个自检问题，避免情绪代替事实',
    category: 'society',
    categoryName: '社会热点',
    author: '编辑 · 程野',
    date: '2026-09-06',
    hot: 3120,
    reading: '4 分钟',
    summary:
      '在参与热点讨论前，先问自己信息来源是否单一、时间线是否完整、结论是否过早，能显著提升讨论质量。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20speech%20bubbles%20and%20balance%20scale%20warm%20cream%20background%20minimal%20geometric%2C%20soft%20natural%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-05',
  },
  {
    id: 'topic-06',
    title: '体育转会传闻追踪：如何用官方渠道交叉验证',
    category: 'sports',
    categoryName: '体育赛事',
    author: '编辑 · 贺川',
    date: '2026-09-05',
    hot: 1980,
    reading: '3 分钟',
    summary:
      '转会期的传闻数量远超官宣，本文整理了几类可靠的交叉验证渠道，帮助读者过滤掉大部分噪音。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20jersey%20and%20arrow%20shapes%20warm%20cream%20background%20minimal%20geometric%2C%20soft%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-06',
  },
  {
    id: 'topic-07',
    title: '从零开始逛爆料专区：新用户的第一小时路线图',
    category: 'society',
    categoryName: '社会热点',
    author: '编辑 · 阿澜',
    date: '2026-09-04',
    hot: 4460,
    reading: '5 分钟',
    summary:
      '把新用户最常问的问题串成一条路线：先看什么、再搜什么、最后订阅什么，一小时内建立基本的使用习惯。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20compass%20and%20route%20map%20warm%20cream%20paper%20background%20minimal%20geometric%2C%20soft%20natural%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-07',
  },
  {
    id: 'topic-08',
    title: '话题热度是怎么算的：站内排序规则简单说明',
    category: 'tech',
    categoryName: '科技数码',
    author: '编辑 · 周牧',
    date: '2026-09-03',
    hot: 1620,
    reading: '3 分钟',
    summary:
      '公开说明站内热度排序考虑的几个维度，包括互动速度、跟帖深度与时间衰减，让排序结果更容易被理解。',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20thermometer%20and%20bar%20chart%20warm%20cream%20background%20minimal%20geometric%2C%20soft%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-topic-08',
  },
];